import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Lock } from "lucide-react";
import { adminLogin, formatApiError } from "@/lib/api";
import { Field, SubmitButton } from "@/components/FormBits";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await adminLogin(email, password);
      localStorage.setItem("ngawilyi_admin_token", data.access_token);
      toast.success(`Welcome back, ${data.user.name}.`);
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 pt-32 pb-20 bg-cream grain relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-blush/40 organic-blob blur-3xl" />
      <div className="relative w-full max-w-md">
        <div className="rounded-[40px] bg-creamdark border border-ochre/25 p-10 sm:p-12 shadow-[0_20px_40px_rgba(74,55,40,0.06)]">
          <div className="rounded-2xl bg-terracotta/15 p-4 w-fit mb-6">
            <Lock className="h-6 w-6 text-terracotta" />
          </div>
          <h1 className="font-display font-light text-4xl text-charcoal">Admin <span className="italic text-terracotta">sign in</span></h1>
          <p className="mt-3 text-sm text-earth/75 leading-relaxed">
            Private area for the Ngawilyi team — referrals, consultation EOIs and messages in one place.
          </p>
          <form data-testid="admin-login-form" onSubmit={onSubmit} className="mt-8 space-y-5">
            <Field label="Email" testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
            <Field label="Password" testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            <div className="pt-2">
              <SubmitButton testid="admin-login-submit-btn" busy={busy}>Sign In</SubmitButton>
            </div>
          </form>
        </div>
        <Link data-testid="admin-back-link" to="/" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-earth hover:text-terracotta transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to website
        </Link>
      </div>
    </div>
  );
};

export default AdminLogin;
